import React from "react";
import { Link } from "react-router-dom";
import "./BookCard.css";

interface BookCardProps {
  image: string;
  title: string;
  desc: string;
  // Internal paths open the book page; full URLs open in a new tab
  link?: string;
}

const BookCard: React.FC<BookCardProps> = ({ image, title, desc, link }) => {
  return (
    <div className="book-card horizontal-scroll-card">
      <div className="book-card-img-wrapper">
        <img src={image} alt={title} className="book-card-img" />
      </div>
      <h3 className="book-card-title">{title}</h3>
      <p className="book-card-desc">
        {desc.split(" ").slice(0, 10).join(" ")}
        {desc.split(" ").length > 10 ? "..." : ""}
      </p>{" "}
      {link?.startsWith("/") ? (
        <Link to={link} className="book-card-new-btn book-card-buy-btn">
          Buy Now
          <svg className="book-card-buy-arrow" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3 8h10M9 4l4 4-4 4" />
          </svg>
        </Link>
      ) : link ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="book-card-new-btn book-card-buy-btn"
        >
          Buy Now
          <svg className="book-card-buy-arrow" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3 8h10M9 4l4 4-4 4" />
          </svg>
        </a>
      ) : (
        <button className="book-card-new-btn">Coming Soon</button>
      )}
      {/* <div className="book-card-view-btn-wrapper">
        <button className="book-card-view-btn">View</button>
      </div> */}
    </div>
  );
};

export default BookCard;
